import React, { Component } from 'react';
import StepZilla from 'react-stepzilla';
import '../App.css';
import 'react-stepzilla/src/css/main.css';

import SubBU from './steps/SubBU.jsx';
import GitURL from './steps/GitURL.jsx';
import Summary from './steps/Summary.jsx';

class CreateNewConsumerHome extends Component {

	constructor(props) {
		super(props);
		this.state = {
			//used for naming prefix
			subBU:'WSRS',
			//used to determine the product name + the owning AD group, see the comment below
			gitURL:'',
			//used for the relevant pfg sign on type for apps that use forgerock. NONE//CLIENTCREDENTIALS//USERCONTEXT
			pfgSignOnType:'NONE'
		};
	}

	getStore = () => {
		return this.state;
	}

	updateStore = (update) => {
		this.setState(update);
	}

	render() {
		const createNewConsumerSteps = [
			{name: 'SubBU', component: <SubBU updateStore={this.updateStore} getStore={this.getStore}/>},
			{name: 'GitURL', component: <GitURL updateStore={this.updateStore} getStore={this.getStore}/>},
			{name: 'Summary', component: <Summary getStore={this.getStore}/>}
		];
		return (

			<div className="container">
				<h1>Create New Consumer</h1>
				<hr/>
				<div className='step-progress'>
					<StepZilla
						nextButtonCls="btn btn-next btn-primary btn-sm pull-right util-margin-top-50"
						backButtonCls="btn btn-prev btn-primary btn-sm pull-left util-margin-top-50"
						steps={createNewConsumerSteps}
					/>
				</div>
			</div>
		);
	}
}

export default CreateNewConsumerHome;
